import { kebabCase } from '~/design-system/helpers/misc'
import { formatPrice } from '~/helpers/number'

/**
 * Helper function to adapt product list to GA4 format
 */
export const _convertProductListToGA4 = (products: any[] = []) => {
  return products.map((product) => {
    const item_list_name = kebabCase(
      (product?.list || '').replace('/#', 'home#').replace(product?.list === '/' ? '/' : '######', 'home'),
    )

    const data = {
      item_name: product?.name,
      item_id: product?.id,
      price: formatPrice(product?.price ?? 0),
      item_brand: product?.brand,
      item_category: product?.category,
      item_variant: product?.variant,
      item_list_name,
      item_list_id: product?.list ? item_list_name : undefined,
      index: product?.position || 1,
      quantity: product?.quantity || 1,
    }

    return data
  })
}
